import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import PlanPriceDisplay from './PlanPriceDisplay';
import { BILLING_CYCLES, sellingPriceForCycle } from '../../utils/planPricing';

export { BILLING_CYCLES };

export function priceForCycle(plan, cycle) {
  return sellingPriceForCycle(plan, cycle);
}

export function formatPrice(amount, currency = 'INR') {
  const sym = currency === 'INR' ? '₹' : currency;
  return `${sym}${Number(amount).toLocaleString('en-IN')}`;
}

/**
 * @param {object} props
 * @param {string} props.cycle
 * @param {(cycle: string) => void} props.onCycleChange
 * @param {object} [props.plan] - when set, shows price for selected cycle below tabs
 * @param {string} [props.className]
 */
export default function PlanPricingTabs({ cycle, onCycleChange, plan, className = '' }) {
  return (
    <div className={className}>
      <Tabs value={cycle} onValueChange={onCycleChange}>
        <TabsList className="grid w-full grid-cols-3 h-auto">
          {BILLING_CYCLES.map((c) => (
            <TabsTrigger key={c.key} value={c.key} className="text-xs sm:text-sm py-2">
              {c.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {plan && BILLING_CYCLES.map((c) => (
          <TabsContent key={c.key} value={c.key} className="mt-3">
            <PlanPriceDisplay plan={plan} cycle={c.key} size="md" />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
